var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Layout',{attrs:{"navFixed":false,"transparent":"true","invert":"true","fixed":"true","hideCart":"true"}},[_c('div',{staticClass:"container pt-5 pb-5 mt-4"},[_c('OrderDetail',{attrs:{"code":_vm.code}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }